




























































import Vue from 'vue';
import { GdPictureOcrServiceSettingsModel } from '@/types/models/taskService/customSettings/gdPictureOcrServiceSettingsModel';
import { FeedbackHelper } from '@/mixins/feedbackHelper';
import { ValidationModel } from '@/types/models/validation';
import { MStoreInputType } from '@/types';

export default Vue.extend({
  name: 'GdPictureOcrServiceSettings',
  mixins: [FeedbackHelper],
  props: {
    settings: {
      type: Object as () => GdPictureOcrServiceSettingsModel
    },
    isEditMode: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    onAddItemClicked() {
      const paths = [...this.resourceFolderSearchPaths];
      paths.push('');
      this.resourceFolderSearchPaths = paths;
    },
    onRemoveItemClicked(index: number) {
      const paths = [...this.resourceFolderSearchPaths];
      paths.splice(index, 1);
      this.resourceFolderSearchPaths = paths;
      this.setAllItemsDirty();
    },
    setAllItemsDirty() {
      const inputs = this.$refs.inputs as any[];
      if (inputs) {
        for (const r of inputs) {
          r.setDirty();
        }
      }
    },
    hasDuplicates(paths: string[]): boolean {
      const normalizedPaths = paths.map((p) => p.trim().toLowerCase()).filter((p) => p !== '');
      return normalizedPaths.length !== new Set(normalizedPaths).size;
    }
  },

  computed: {
    resourceFolderSearchPaths: {
      get(): string[] {
        return this.settings?.resourceFolderSearchPaths || [];
      },
      set(value: string[]) {
        this.$emit('update', { key: 'resourceFolderSearchPaths', value });
      }
    },
    maximumPagesToEnqueuePerInterval: {
      get(): number {
        return this.settings?.maximumPagesToEnqueuePerInterval || 0;
      },
      set(value: number) {
        this.$emit('update', { key: 'maximumPagesToEnqueuePerInterval', value });
      }
    },
    validationRuleForIndex(this: any) {
      return (index: number): ValidationModel => {
        const otherPaths = this.resourceFolderSearchPaths.filter((_: string, i: number) => i !== index);

        const validationModel: ValidationModel = {
          required: true,
          maxLength: 200,
          windowsFolderPath: true,
          unique: otherPaths
        };

        return validationModel;
      };
    },
    numberInputType() {
      return MStoreInputType.Number;
    }
  },
  components: {
    MStoreFormInput: () => import('@/components/shared/MStoreFormInput.vue')
  }
});
